import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { IrregularidadeEmpresaCadastroComponent } from "./cadastro/irregularidade_empresa.cadastro.component";
import { IrregularidadeEmpresaPesquisaComponent } from "./pesquisa/irregularidade_empresa.pesquisa.component";

const routes: Routes = [
    {
        path: 'irregularidade-empresa/pesquisa',
        component: IrregularidadeEmpresaPesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false },
    },
    {
        path: 'irregularidade-empresa',
        component: IrregularidadeEmpresaCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        data: { canReuse: false },
    },
    {
      path: 'irregularidade-empresa/:id',
      component: IrregularidadeEmpresaCadastroComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      data: { canReuse: false },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class IrregularidadeEmpresaRoutingModule {}


